const files = import.meta.glob('../ico/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true
});

function scopeClasses(markup, prefix) {
  const withAttrs = markup.replace(/\bclass=(["'])([^"']*)\1/g, (_, quote, list) => {
    const next = list
      .split(/\s+/)
      .filter(Boolean)
      .map((name) => `${prefix}${name}`)
      .join(' ');
    return `class=${quote}${next}${quote}`;
  });

  return withAttrs.replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, (block) => (
    block.replace(/\.(-?[_a-zA-Z][\w-]*)/g, `.${prefix}$1`)
  ));
}

const symbols = Object.entries(files).filter(([file]) => !file.endsWith('line-0.svg')).map(([file, raw]) => {
  const base = file.split('/').pop().replace(/\.svg$/i, '');
  const id = base.replace(/"/g, '');
  const source = String(raw);
  const viewBox = (source.match(/viewBox="([^"]+)"/) || [])[1] || '0 0 32 32';
  const inner = source
    .replace(/<\?xml[^>]*>/g, '')
    .replace(/<!DOCTYPE[^>]*>/g, '')
    .replace(/<svg[^>]*>/i, '')
    .replace(/<\/svg>\s*$/i, '')
    .replace(/<title>[\s\S]*?<\/title>/gi, '');
  const scoped = scopeClasses(inner, `${id}__`);
  return `<symbol id="${id}" viewBox="${viewBox}">${scoped}</symbol>`;
});

const host = document.createElement('div');
host.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" style="position:absolute;width:0;height:0;overflow:hidden">${symbols.join('')}</svg>`;
document.body.prepend(host.firstChild);
